import React, { useState, useEffect } from "react";
import "./index.css";
import { Link, useLocation } from "react-router-dom";
// import userCheck from "../../utils/checkUser";
import { useCan } from "../../utils/permissions";
const Index = () => {
  const location = useLocation();
  const can = useCan();
  const canReadUser = can("user", "read");
  const canCreateUser = can("user", "create");
  const canUpdateUser = can("user", "update");
  const canDeleteUser = can("user", "delete");

  const canReadRole = can("role", "read");
  const canCreateRole = can("role", "create");
  const canUpdateRole = can("role", "update");
  const canDeleteRole = can("role", "delete");

  const canReadTask = can("task", "read");
  const canCreateTask = can("task", "create");
  const canUpdateTask = can("task", "update");
  const canDeleteTask = can("task", "delete");

  const canDeleteSurvey = can("surveyTemplate", "delete");
  const canReadAppointment = can("appointment", "read");
  const canReadWorkOrder = can("workOrders", "read");
  const canReadaudit = can("audit", "read");

  // console.log(location);useLocation
  // const [showButton, setShowButton] = useState(false);

  // useEffect(() => {
  //   setShowButton(userCheck());
  // }, []);

  return (
    <div className="subheader">
      {canReadWorkOrder &&
        <Link
          to="/work-order"
          className={`contH ${location.pathname === "/work-order" ? "active1" : "inactive1"
            }`}
        >
          Work Orders
        </Link>
      }
      {canReadAppointment &&
        <Link
          to="/appointments"
          className={`contH ${location.pathname === "/appointments" ? "active1" : "inactive1"
            }`}
        >
          Appointments
        </Link>
      }
      {canReadTask && canCreateTask && canUpdateTask && canDeleteTask &&
        <Link
          to="/survey-results"
          className={`contH ${location.pathname === "/survey-results" ? "active1" : "inactive1"
            }`}
        >
          Survey Results
        </Link>
      }
      {canDeleteSurvey &&
        <Link
          to="/template-builder"
          className={`contH ${location.pathname === "/template-builder" ? "active1" : "inactive1"
            }`}
        >
          Template Builder
        </Link>
      }
      {canReadUser && canCreateUser && canUpdateUser && canDeleteUser &&
        <Link
          to="/technicians"
          className={`contH ${location.pathname === "/technicians" ? "active1" : "inactive1"
            }`}
        >
          Technicians
        </Link>
      }
      {canReadRole && canUpdateRole && canCreateRole && canDeleteRole &&
        <Link
          to="/role"
          className={`contH ${location.pathname === "/role" ? "active1" : "inactive1"
            }`}
        >
          Role
        </Link>
      }
      {canReadUser && canCreateUser && canUpdateUser && canDeleteUser && <Link
        to="/user"
        className={`contH ${location.pathname === "/user" ? "active1" : "inactive1"
          }`}
      >
        User
      </Link>
      }
      {canReadaudit &&
        <Link
          to="/audit"
          className={`contH ${location.pathname === "/audit" ? "active1" : "inactive1"
            }`}
        >
          Audit
        </Link>
      }
    </div>
  );
};

export default Index;
